import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';
import moment from 'moment';

const initialState = {
    addPackage: {
        packageID: {
            value: "",
            error: "",
            showError: "",
        },
        drawing: {
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        fabBomAttachment:{
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        fieldBomAttachment:{
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        hangerBomAttachment:{
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        fieldDrawing: {
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        hangersDrawing: {
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        msaccessFile: {
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        fieldMsaccessFile: {
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        hangerXlsxFile: {
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        jobNumber: {
            value: "",
            error: "",
            showError: "",
        },
        fieldMaterial: {
            value: "",
            error: "",
            showError: "",
        },
        structureType: {
            value: "",
            error: "",
            showError: "",
        },
        fabricationMaterial: {
            value: "",
            error: "",
            showError: "",
        },
        package: {
            value: "",
            error: "",
            showError: "",
        },
        packageColor: {
            value: "",
            error: "",
            showError: "",
        },
        requiredDate: {
            value: "",
            error: "",
            showError: "",
        },
        fieldNote: {
            value: "",
        },
        fieldNoteId: {
            value: "",
        },
        hangerNoteId: {
            value: "",
        },
        fabricationNote: {
            value: "",
        },
        hangerNote: {
            value: "",
        },
        fabricationNoteId: {
            value: "",
        },
        projectCode: {
            value: "",
        },
        colorCode: {
            value: "",
        },
        shippingDate: {
            value: "",
        },
        fabmaterial: {
            value: '',
        },
        fieldmaterial: {
            value: '',
        },
        jobnumbers: [],
        error: '',
        showAddProject: false,
        packageType: {
            revision: false,
            newPackage: false,
            existing: false,
        },
        disablePackage: false,
        fieldDisable: false,
        hangersDisable: false,
        fabDisable: false,
        packages: [],
        fabMaterials: [],
        fieldMaterials: [],
        structureTypes: [],
        isSubmitted: false,
        wait: false,
        optionsLoading: false,
        stainlessCheckbox: false,
        fabFacilityList:[], 
        selectedFacility: {value: "", label: "Select Fabrication Facility"},
        isThirdPartyExaminationRequired: false,
        lotSize: null,
        prefixSuggestions: [],
        cachedPrefixes: {},
        miscFabTasksList: [],
        miscFabCategoryList: [],
        isDuplicatePackage: false,
        duplicateMessage: '',
        uploadButtonDisable: false,
    },
}

const addPackage = createNamespacer("ADD_PACKAGE")

export const  addPackageReducer = createReducer(initialState.addPackage, {
    [addPackage("SET_PACKAGE_ID")]:(state, action) => {
        return {
            ...state,
            packageID: {
                ...state.packageID,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET_PREFIX_SUGGETIONS")]: (state, action) => {
        return {
            ...state,
            prefixSuggestions: action.payload.value,
        }
    },
    [addPackage("SET_DUPLICATE_PACKAGE")]: (state, action) => {
        return {
            ...state,
            isDuplicatePackage: action.payload.value,
            duplicateMessage: action.payload.duplicateMessage
        }
    },
    [addPackage("SET_CACHED_PREFIX_SUGGETIONS")]: (state, action) => {
        return {
            ...state,
            cachedPrefixes: {
                ...state.cachedPrefixes,
                ...action.payload,
            },
        }
    },
    [addPackage("SET_HANGER_NOTE")]:(state, action) => {
        return {
            ...state,
            hangerNote: {
                ...state.hangerNote,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET_FABRICATION_EMAIL_NOTE")]:(state, action) => {
        return {
            ...state,
            fabricationNote: {
                ...state.fabricationNote,
                value: action.payload.value,
            },
        }

    },
    [addPackage("TOGGLE_STAINLESS_CHECKBOX")]: (state,action) => {
        return {
            ...state,
            stainlessCheckbox: action.payload.value,
        }
    },
    [addPackage("SET_FIELD_EMAIL_NOTE")]:(state, action) => {
        return {
            ...state,
            fieldNote: {
                ...state.fieldNote,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET_DRAWING")]:(state, action) => {
        return {
            ...state,
            drawing: {
                ...state.drawing,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET_DRAWING_NAME")]:(state, action) => {
        return {
            ...state,
            drawing: {
                ...state.drawing,
                name: action.payload.value,
            },
        }

    },
    [addPackage("SET_FAB_BOM_ATTACHMENT")]:(state, action) => {
        return {
            ...state,
            fabBomAttachment: {
                ...state.fabBomAttachment,
                value: action.payload.value,
                name: action.payload.name,
            },
        }

    },
    [addPackage("SET_FIELD_BOM_ATTACHMENT")]:(state, action) => {
        return {
            ...state,
            fieldBomAttachment: {
                ...state.fieldBomAttachment,
                value: action.payload.value,
                name: action.payload.name,
            },
        }

    },
    [addPackage("SET_HANGER_BOM_ATTACHMENT")]:(state, action) => {
        return {
            ...state,
            hangerBomAttachment: {
                ...state.hangerBomAttachment,
                value: action.payload.value,
                name: action.payload.name,
            },
        }

    },
    [addPackage("SET_FIELD_DRAWING")]:(state, action) => {
        return {
            ...state,
            fieldDrawing: {
                ...state.fieldDrawing,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET_FIELD_DRAWING_NAME")]:(state, action) => {
        return {
            ...state,
            fieldDrawing: {
                ...state.fieldDrawing,
                name: action.payload.value,
            },
        }

    },
    [addPackage("SET_HANGER_DRAWING")]:(state, action) => {
        return {
            ...state,
            hangersDrawing: {
                ...state.hangersDrawing,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET_HANGER_DRAWING_NAME")]:(state, action) => {
        return {
            ...state,
            hangersDrawing: {
                ...state.hangersDrawing,
                name: action.payload.value,
            },
        }

    },
    [addPackage("SET_MS_ACCESS_FILE")]:(state, action) => {
        return {
            ...state,
            msaccessFile: {
                ...state.msaccessFile,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET__MSACCESS_FILE_NAME")]:(state, action) => {
        return {
            ...state,
            msaccessFile: {
                ...state.msaccessFile,
                name: action.payload.value,
            },
        }

    },
    [addPackage("SET_FIELD_MS_ACCESS_FILE")]:(state, action) => {
        return {
            ...state,
            fieldMsaccessFile: {
                ...state.fieldMsaccessFile,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET_FIELD_MSACCESS_FILE_NAME")]:(state, action) => {
        return {
            ...state,
            fieldMsaccessFile: {
                ...state.fieldMsaccessFile,
                name: action.payload.value,
            },
        }

    },
    [addPackage("SET_HANGER_XLSX_FILE")]:(state, action) => {
        return {
            ...state,
            hangerXlsxFile: {
                ...state.hangerXlsxFile,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET_HANGER_XLSX_FILE_NAME")]:(state, action) => {
        return {
            ...state,
            hangerXlsxFile: {
                ...state.hangerXlsxFile,
                name: action.payload.value,
            },
        }

    },
    [addPackage("SET_JOB_NUMBER")]:(state, action) => {
        return {
            ...state,
            jobNumber: {
                ...state.jobNumber,
                value: action.payload.value,
            },
            disablePackage: action.payload.disablePackage,
        }

    },
    [addPackage("SET_EXAMINATION_CHECKED")]: (state, action) => {
        return {
            ...state,
            isThirdPartyExaminationRequired: !action.payload.isThirdPartyExaminationRequired,
        }
    },
    [addPackage("SET_EXAMINATION_PERCENTAGE")]: (state, action) => {
        return {
            ...state,
            lotSize: action.payload.lotSize,
        }
    },
    [addPackage("SET_FIELD_MATERIAL")]:(state, action) => {
        return {
            ...state,
            fieldMaterial: {
                ...state.fieldMaterial,
                value: action.payload.value,                

            } 
        }
    },
    [addPackage("SET_STRUCTURE_TYPE")]:(state, action) => {
        return {
            ...state,
            structureType: {
                ...state.structureType,
                value: action.payload.value,                

            } 
        }
    },
    [addPackage("SET_FABRICATION_MATERIAL")]:(state, action) => {
        return {
            ...state,
            fabricationMaterial: {
                ...state.fabricationMaterial,
                value: action.payload.value,                

            } 
        }
    },
    [addPackage("SET_PACKAGE")]:(state, action) => {
        return {
            ...state,
            package: {
                ...state.package,
                value: action.payload.value,                
            } 
        }
    },

    [addPackage("LOAD_EXISTING_PACKAGES")]:(state, action) => {
        return {
            ...state,
            optionsLoading: action.payload.value,
        }
    },
    
    [addPackage("SET_PROJECT_CODE")]:(state, action) => {
        return {
            ...state,
            projectCode: action.payload.value,
        }
    },
    [addPackage("SET_JOB_NUMBERS")]:(state, action) => {
        return {
            ...state,
            jobnumbers: action.payload.value
        }
    },
    [addPackage("SET_UPLOAD_DISABLE")]:(state, action) => {
        return {
            ...state,
            uploadButtonDisable: action.payload.value
        }
    },
    [addPackage("SET_EXTRA_JOB_NUMBERS")]:(state, action) => {
        return {
            ...state,
            jobnumbers: [
                ...state.jobnumbers,
                ...action.payload.value
            ],
        }
    },
    [addPackage("SET_PACKAGE_TYPE")]:(state, action) => {
        let updatePackageType = {
            ...initialState.addPackage.packageType,
            [action.payload.value]: true
        }
        return {
            ...state,
            packageType: updatePackageType,
            disablePackage: action.payload.disablePackage,
        }
    },
    
    [addPackage("SET_PACKAGES")]:(state, action) => {
        return {
            ...state,
            packages: [
                ...action.payload.value
            ],
        }
    },
    [addPackage("SET_FACILITIES_LIST")]:(state, action) => {
        return {
            ...state,
            fabFacilityList: [
                ...action.payload.value
            ],
        }
    },
    [addPackage("SET_FACILITY")]:(state, action) => {
        return {
            ...state,
            selectedFacility: action.payload
        }
    },
    [addPackage("SET_MATERIALS")]:(state, action) => {
        return {
            ...state,
            fabMaterials: action.payload.fabMaterials,
            fieldMaterials: action.payload.fieldMaterials,
            hangerMaterials: action.payload.hangerMaterials,
        }
    },
    [addPackage("SET_MISC_FAB_TASKS_LIST")]:(state, action) => {
        return {
            ...state,
            miscFabTasksList: action.payload.value,
        }
    },
    [addPackage("SET_MISC_FAB_CATEGORY_LIST")]:(state, action) => {
        return {
            ...state,
            miscFabCategoryList: action.payload.value,
        }
    },
    [addPackage("SET_NEW_TASK")]:(state, action) => {
        return {
            ...state,
            miscFabTasksList: [...state.miscFabTasksList, action.payload.task],
        }
    },
    [addPackage("SET_STRUCTURE_TYPES")]:(state, action) => {
        return {
            ...state,
            structureTypes: action.payload.structureTypes,
        }
    },
    [addPackage("SET_REQUIRED_DATE")]:(state, action) => {
        return {
            ...state,
            requiredDate: {
                ...state.requiredDate,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET_WAIT")]:(state, action) => {
        return {
            ...state,
            wait: action.payload.value,
        }
    },
    [addPackage("SET_ISSUBMITTED")]:(state, action) => {
        return {
            ...state,
            isSubmitted: action.payload.value,
        }
    },
    [addPackage("SET_ERROR")]:(state, action) => {
        return {
            ...state,
            error: {
                ...state.error,
                value: action.payload.value,
            },
        }

    },
    [addPackage("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
    [addPackage("CLEAR_FORM")] : (state, action) => {
        return {
            ...initialState.addPackage, 
        }
    },
    [addPackage("CLEAR_TOGGLE_FORM")] : (state, action) => {
        return {
            ...initialState.addPackage, 
            packages: [
                ...state.packages
            ],
            fabMaterials: [
                ...state.fabMaterials
            ],
            jobnumbers: [
                ...state.jobnumbers
            ],
            packageType: {
                ...state.packageType
            },
            fieldMaterials: [
                ...state.fieldMaterials
            ],
            structureTypes: [
                ...state.structureTypes
            ]
        }
    },
    [addPackage("CLEAR_LOAD_DATA")] : (state, action) => {
        return {
            ...state, 
            msaccessFile: { ...initialState.addPackage.msaccessFile },
            drawing: { ...initialState.addPackage.drawing },
            fabBomAttachment: { ...initialState.addPackage.fabBomAttachment },
            fieldBomAttachment: { ...initialState.addPackage.fieldBomAttachment },
            fieldMsaccessFile: { ...initialState.addPackage.fieldMsaccessFile },
            fieldDrawing: { ...initialState.addPackage.fieldDrawing },
            fabricationNote: { ...initialState.addPackage.fabricationNote},
            fieldNote: { ...initialState.addPackage.fieldNote},
        }
    },
    
    [addPackage("LOAD_DATA")]: (state, action) => {
        let loadedFab, loadedField, loadedHanger, stainlessCheckbox, fieldDisable, fabDisable, hangersDisable, fieldNote, fabricationNote, fabmaterial, fieldmaterial, structureType, hangerNote;
        let response = action.payload.value;

        if(action.payload.existing){
            const responseMappingfab= {
                fabBomAttachment: 'fab_bom_name',
                msaccessFile: 'fab_mdb_name',
                drawing:'fab_zip_name',
            }
    
            const responseMappingfield= {
                fieldBomAttachment: 'field_bom_name',
                fieldMsaccessFile: 'field_mdb_name',
                fieldDrawing: 'field_zip_name',
            }

            const responseMappingHanger= {
                hangerBomAttachment: 'hanger_bom_name',
                hangerXlsxFile: 'hanger_mdb_name',
                hangerDrawing: 'hanger_pdf_name',
            }

            if(response.fabrication) {
                loadedFab = _fromPairs(
                    Object.entries(responseMappingfab).map((entry) => {
                        const [key, responseKey] = entry;
                        return [key, {
                            ...state[key],
                            name: response.fabrication[responseKey]
                        }]
                    })
                )

                fabDisable =  !!response.fabrication.fab_mdb_name
                fabricationNote = { value: response.fabrication.email_note }
                fabmaterial = { value: response.fabrication.material }
            } 
            if(response.hanger) {
                loadedHanger = _fromPairs(
                    Object.entries(responseMappingHanger).map((entry) => {
                        const [key, responseKey] = entry;
                        return [key, {
                            ...state[key],
                            name: response.hanger[responseKey]
                        }]
                    })
                )

                hangersDisable =  !!response.hanger.hanger_mdb_name
                stainlessCheckbox = response.hanger.material === "Stainless Steel" ? true : false
                hangerNote = { value: response.hanger.email_note }
                structureType = { value: response.hanger.material }
            } 

            if(response.field) {
                loadedField = _fromPairs(
                    Object.entries(responseMappingfield).map((entry) => {
                        const [key, responseKey] = entry;
                        return [key, {
                            ...state[key],
                            name: response.field[responseKey]
                        }]
                    })
                )
                fieldDisable =  !!response.field.field_mdb_name
                fieldNote =  fieldDisable ? { value: response.field.email_note } : ''
                fieldmaterial = { value: response.field.material }
            }
        }


        return {
            ...state,
            shippingDate: {
                ...state.shippingDate,
                value: response.fabrication ? (moment(response.fabrication.required_date)): (moment(response.field.required_date)) 
            },
            ...loadedField,
            ...loadedFab,
            ...loadedHanger,
            fabDisable, fieldDisable,hangersDisable, fieldNote, fabricationNote, hangerNote, fieldmaterial, stainlessCheckbox, fabmaterial, structureType
        }
    },
    
})